'use strict';

var _tslib = require('../../../../_virtual/_tslib.js');
var React = require('react');
var getOptimisedImageUrl = require('./utils/getOptimisedImageUrl.js');

var ExlyImage = function (_a) {
    var _b = _a.src, src = _b === void 0 ? "" : _b, fetchWidth = _a.fetchWidth, cdnBaseUrl = _a.cdnBaseUrl, _c = _a.loading, loading = _c === void 0 ? "lazy" : _c, rest = _tslib.__rest(_a, ["src", "fetchWidth", "cdnBaseUrl", "loading"]);
    /**
     * Key attribute is important in order to make the src changed load instantly.
     * https://stackoverflow.com/questions/50690956/react-img-not-immediately-changing-when-src-changes-how-can-i-fix-this
     */
    var processedImgSrc = getOptimisedImageUrl.getOptimisedImageUrl({
        cdnBaseUrl: cdnBaseUrl,
        fetchWidth: fetchWidth,
        imageUrl: src,
    });
    return (React.createElement("img", _tslib.__assign({ key: processedImgSrc, src: processedImgSrc, loading: loading }, rest)));
};

module.exports = ExlyImage;
//# sourceMappingURL=ExlyImage.js.map
